// doujin.sexy is the only brand this app serves. manga.sexy was a second one,
// switched here by hostname; the domain is unregistered (NXDOMAIN) and the
// branch was removed with #225. Kept as a function so every caller stays as
// it is.
const DOUJIN = Object.freeze({
  siteKey: 'doujin',
  siteTitle: 'Doujin.sexy',
  gaId: 'UA-176119053-1'
})

export function currentSite() {
  return { ...DOUJIN }
}
